import produce from 'immer'
import { ImmutableVector3 } from '@modugen/ui-toolkit'

export const translateOpening = (
  opening: Opening,
  direction: ImmutableVector3,
  distance: number,
) => {
  const newOpening = produce(opening => {
    opening.shape.points = opening.shape.points.map(p => {
      return p.addScaledVector(direction, distance)
    })
  }, opening)()

  return newOpening
}
